var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgMastercardCard = function SvgMastercardCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 51,
    viewBox: "0 0 81 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mastercard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.3167 6.06299H29.6843V44.9369H51.3167V6.06299Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.058 25.5C31.0546 21.7562 31.903 18.0606 33.5389 14.6931C35.1749 11.3257 37.5555 8.37449 40.5006 6.06307C36.8535 3.19636 32.4734 1.4136 27.861 0.918542C23.2486 0.423489 18.59 1.2361 14.4176 3.26354C10.2452 5.29098 6.72739 8.45143 4.26626 12.3836C1.80514 16.3158 0.5 20.8611 0.5 25.5C0.5 30.1389 1.80514 34.6842 4.26626 38.6164C6.72739 42.5486 10.2452 45.7091 14.4176 47.7365C18.59 49.764 23.2486 50.5766 27.861 50.0815C32.4734 49.5865 36.8535 47.8037 40.5006 44.937C37.5555 42.6256 35.1749 39.6744 33.5389 36.3069C31.903 32.9394 31.0546 29.2439 31.058 25.5Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M80.5001 25.5C80.5003 30.1389 79.1953 34.6842 76.7343 38.6164C74.2733 42.5486 70.7556 45.709 66.5833 47.7365C62.411 49.7639 57.7524 50.5766 53.1401 50.0815C48.5277 49.5865 44.1477 47.8037 40.5007 44.937C43.4433 42.6232 45.822 39.6716 47.4577 36.3046C49.0934 32.9377 49.9433 29.2433 49.9433 25.5C49.9433 21.7568 49.0934 18.0624 47.4577 14.6954C45.822 11.3285 43.4433 8.37682 40.5007 6.06306C44.1477 3.19635 48.5277 1.41358 53.1401 0.918535C57.7524 0.423488 62.411 1.23614 66.5833 3.2636C70.7556 5.29105 74.2733 8.4515 76.7343 12.3837C79.1953 16.3159 80.5003 20.8612 80.5001 25.5Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M78.1414 40.8197V40.0238H78.4623V39.8617H77.645V40.0238H77.9661V40.8197H78.1414ZM79.7281 40.8197V39.8601H79.4776L79.1895 40.5201L78.9012 39.8601H78.6505V40.8197H78.8275V40.0959L79.0977 40.7199H79.2811L79.5514 40.0943V40.8197H79.7281Z",
    fill: "#F79E1B"
  }))));
};
var Memo = /*#__PURE__*/memo(SvgMastercardCard);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/mastercard-card.7f792f393990a48a24d316ff2def8493.svg";